import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Plus, KeyRound, UserX, UserCheck, Trash2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Modal } from "../../components/shared/Modal";

export default function ManageShopAdmins() {
  const [admins, setAdmins] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: "", email: "" });
  const { authAxios } = useAuth();

  const load = () => authAxios.get("/shop-admins").then(r => setAdmins(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.name || !form.email) return toast.error("Name and email required");
    try {
      const res = await authAxios.post("/shop-admins", form);
      toast.success(`Created. Temp password: ${res.data.temp_password}`);
      setShowForm(false); setForm({ name: "", email: "" }); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  const toggleActive = async (a) => {
    try { await authAxios.put(`/shop-admins/${a.id}`, { is_active: !a.is_active }); toast.success("Updated"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  const resetPw = async (a) => {
    try { await authAxios.post(`/shop-admins/${a.id}/reset-password`); toast.success("Password reset, email sent"); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  const remove = async (a) => {
    try { await authAxios.delete(`/shop-admins/${a.id}`); toast.success("Deleted"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  return (
    <div data-testid="manage-shop-admins">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-[#1e3a5f]">Shop Admins ({admins.length})</h3>
        <button onClick={() => setShowForm(true)} className="flex items-center gap-1 px-4 py-2 rounded-full bg-[#0ea5e9] text-white text-sm font-medium" data-testid="add-shop-admin-btn">
          <Plus className="w-4 h-4" /> Add Shop Admin
        </button>
      </div>
      <div className="space-y-2">
        {admins.map(a => (
          <div key={a.id} className="bg-white rounded-xl p-4 shadow-sm flex items-center justify-between gap-3">
            <div className="flex-1">
              <p className="font-bold text-[#1e3a5f]">{a.name}</p>
              <p className="text-xs text-slate-500">{a.email}</p>
            </div>
            <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${a.is_active ? "bg-green-100 text-green-600" : "bg-red-100 text-red-600"}`}>{a.is_active ? "Active" : "Inactive"}</span>
            <button onClick={() => resetPw(a)} className="p-2 text-slate-500 hover:text-[#1e3a5f]" title="Reset password"><KeyRound className="w-4 h-4" /></button>
            <button onClick={() => toggleActive(a)} className={`p-2 ${a.is_active ? "text-red-400" : "text-green-500"}`} title={a.is_active ? "Deactivate" : "Activate"}>
              {a.is_active ? <UserX className="w-4 h-4" /> : <UserCheck className="w-4 h-4" />}
            </button>
            <button onClick={() => remove(a)} className="p-2 text-red-400" title="Delete"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        {admins.length === 0 && <p className="text-slate-400 text-sm text-center py-6">No Shop Admins yet</p>}
      </div>
      {showForm && (
        <Modal title="New Shop Admin" onClose={() => setShowForm(false)}>
          <div className="space-y-3">
            <div><label className="text-xs text-slate-500">Name *</label><input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full px-3 py-2 rounded-xl border text-sm" data-testid="shop-admin-name" /></div>
            <div><label className="text-xs text-slate-500">Email *</label><input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full px-3 py-2 rounded-xl border text-sm" data-testid="shop-admin-email" /></div>
            <button onClick={create} className="w-full py-3 rounded-full bg-[#0ea5e9] text-white font-bold" data-testid="save-shop-admin">Create & Email Credentials</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
